// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { initDataBySpecification } from './UserDataRedux'
import { getAllDependencies } from '../SpecificationFunctions'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getDiscountResourcesRequest: ['product'],
  getDiscountResourcesRequestSuccess: ['discountResources'],
  getDiscountContentRequest: ['product'],
  getDiscountContentRequestSuccess: ['discountContent'],
  setDiscount: ['key', 'value'],
  setDiscounts: ['discounts'],
  resetDiscounts: ['includesStringRegex'],
  discountsInit: ['specification'],
  setDiscountDependencies: ['discountSpecification'],
  onChangeDiscountError: [''],
})

export const DiscountsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({ // eslint-disable-line
  discountsInitialized: false,
  discounts: {},
  discountResources: {},
  discountContent: {},
  discountDependencies: [],
})

/* ------------- Reducers ------------- */

export const getDiscountResourcesRequestSuccessR = (state, { discountResources }) =>
  state.merge({ discountResources })

export const getDiscountContentRequestSuccessR = (state, { discountContent }) =>
  state.merge({ discountContent })

export const setDiscountR = (state, { key, value }) =>
  state.setIn(['discounts', ...(Array.isArray(key) ? key : [key])], value)

const setDiscountsR = (state, { discounts }) =>
  state.set('discounts', discounts)

export const resetDiscountsR = (state, { includesStringRegex }) => {
  if (includesStringRegex && typeof includesStringRegex === 'object') {
    return state.merge({
      discounts: Object.keys(state.discounts).reduce((discountsAcc, discountKey) => {
        discountsAcc[discountKey] = Object.keys(state.discounts[discountKey]).reduce((itemAcc, itemKey) => {
          if (includesStringRegex.test(itemKey)) {
            if (typeof state.discounts[discountKey][itemKey] === 'object') {
              itemAcc[itemKey] = {}
            } else if (typeof state.discounts[discountKey][itemKey] === 'string') {
              itemAcc[itemKey] = ''
            } else if (typeof state.discounts[discountKey][itemKey] === 'boolean') {
              itemAcc[itemKey] = false
            }
          } else {
            itemAcc[itemKey] = state.discounts[discountKey][itemKey]
          }
          return itemAcc
        }, {})
        return discountsAcc
      }, {})
    })
  }
  return state.merge({ discounts: INITIAL_STATE.discounts })
}

const setDiscountDependenciesR = (state, { discountSpecification }) =>
  state.set('discountDependencies', getAllDependencies(discountSpecification))

const discountsInitR = (state, { specification }) => {
  const { data } = initDataBySpecification(specification, state.discounts.asMutable(), {})
  return state.merge({ discountsInitialized: true, discounts: data })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_DISCOUNT_RESOURCES_REQUEST]: state => state,
  [Types.GET_DISCOUNT_RESOURCES_REQUEST_SUCCESS]: getDiscountResourcesRequestSuccessR,
  [Types.GET_DISCOUNT_CONTENT_REQUEST]: state => state,
  [Types.GET_DISCOUNT_CONTENT_REQUEST_SUCCESS]: getDiscountContentRequestSuccessR,
  [Types.SET_DISCOUNT]: setDiscountR,
  [Types.SET_DISCOUNTS]: setDiscountsR,
  [Types.RESET_DISCOUNTS]: resetDiscountsR,
  [Types.SET_DISCOUNT_DEPENDENCIES]: setDiscountDependenciesR,
  [Types.DISCOUNTS_INIT]: discountsInitR,
})
